export default defineNuxtPlugin(async () => {
  const userStore = useUserStore()
  try {
    await userStore.getData()
  } catch {
    /**/
  }
})
